var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-wrapper-item",on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"icon"},[_c('i',{staticClass:"fas fa-chevron-right"})])
}]

export { render, staticRenderFns }